import React, { useState, useEffect } from 'react';
import './Home.css';

import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';


import holder1 from '../assets/holder1.png';
import holder2 from '../assets/holder2.png';
import holder3 from '../assets/holder3.png';
import holder4 from '../assets/holder4.png';
import holder5 from '../assets/holder5.png';
import holder6 from '../assets/holder6.png';
import holder7 from '../assets/holder7.png';
import bg from '../assets/arcanes_home_background.jpg';

const categories = [
  'Trending', 
  'Programming', 
  'Education', 
  'Business', 
  'Mental Health', 
  'Writing'
];

const cardImages = [holder1, holder2, holder3, holder4, holder5, holder6, holder7];

function Home() {
  const [activeCategory, setActiveCategory] = useState(null);

  // State for Chat Modal (shared agents chat)
  const [chatModalOpen, setChatModalOpen] = useState(false);
  const [currentChatAgent, setCurrentChatAgent] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");

  const [sharedAgents, setSharedAgents] = useState([]);
  // Query Firestore for shared agents (agents where share === true)
  useEffect(() => {
    const q = query(collection(db, 'agents'), where('share', '==', true));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const agentsData = [];
      snapshot.forEach((doc) => {
        agentsData.push({ id: doc.id, ...doc.data() });
      });
      setSharedAgents(agentsData);
    });
    return () => unsubscribe();
  }, []);




    // When a user clicks on a shared agent card, open the chat modal
    const handleStartChat = (agent) => {
        // Prepare a system message using the agent's stored configuration
        const systemMessage = {
          role: "system",
          content: `This is a custom AI agent named ${agent.name}.

    `
        };
    // Description: ${agent.description}
    // Instructions: ${agent.instructions}
    // Capabilities: ${agent.capabilities?.join(', ') || 'N/A'}
        setCurrentChatAgent(agent);
        setChatMessages([systemMessage]);
        setChatModalOpen(true);
      };
    
      const handleCloseChatModal = () => {
        setChatModalOpen(false);
        setChatMessages([]);
        setChatInput("");
        setCurrentChatAgent(null);
      };
    
      // Handle sending a chat message (calls OpenAI Chat API similarly to MyAgents.js)
      const handleSendChatMessage = async () => {
        if (chatInput.trim() === "") return;
        const updatedMessages = [...chatMessages, { role: "user", content: chatInput }];
        setChatMessages(updatedMessages);
        setChatInput("");
        // Determine model to use
        const modelToUse =
          currentChatAgent.model === "GPT-4o" ? "gpt-4o-2024-08-06" : currentChatAgent.model;
        const apiKey = process.env.REACT_APP_OPENAI_API_KEY;
        if (!apiKey) {
          alert("OpenAI API key is not set.");
          return;
        }
        try {
          const response = await fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${apiKey}`
            },
            body: JSON.stringify({
              model: modelToUse,
              messages: updatedMessages,
              max_tokens: 150,
              temperature: 0.7
            })
          });
          const data = await response.json();
          if (data.error) {
            setChatMessages((prev) => [
              ...prev,
              { role: "assistant", content: "Error: " + data.error.message }
            ]);
          } else {
            const assistantMessage = data.choices[0].message.content;
            setChatMessages((prev) => [...prev, { role: "assistant", content: assistantMessage }]);
          }
        } catch (error) {
          console.error("Error calling OpenAI Chat API:", error);
          setChatMessages((prev) => [
            ...prev,
            { role: "assistant", content: "Error: " + error.message }
          ]);
        }
      };

      


  return (
    <div className="home"
    style={{
      backgroundImage: `url(${bg})`,
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>

      <h1 className="main-heading">
        Explore &amp; Share<br />
        Custom AI Agents
      </h1>
      
      
      <input 
        type="text" 
        className="search-bar" 
        placeholder="What AI modules are you looking for?" 
      />
      <div className="category-buttons">
        {categories.map((category, index) => (
          <button 
            key={index} 
            className={`category-button ${activeCategory === category ? 'active' : ''}`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}

        
      </div>
      <div className="cards-grid">
        {cardImages.map((image, index) => (
          <div className="card" key={index}>
            <img 
              src={image} 
              alt={`AI Agent ${index + 1}`} 
              className="card-image"
            />
            <div className="card-overlay">
              <span>Placeholder Text</span>
            </div>
          </div>
        ))}
        

        {sharedAgents.length === 0 ? (
          <p>No shared custom AI agents available yet.</p>
        ) : (
          sharedAgents.map((agent) => (
            <div key={agent.id} className="card" onClick={() => handleStartChat(agent)}>
              {/* Use the agent's thumbnail URL if it exists, otherwise a placeholder image */}
              <img 
                src={agent.thumbnailUrl ? agent.thumbnailUrl : "https://via.placeholder.com/200"}
                alt={agent.name}
                className="card-image"
              />
              <div className="card-overlay">
                <div>
                  <h3>{agent.name}</h3>
                  <p>{agent.description}</p>
                </div>
              </div>
            </div>
          ))
        )}


      </div>

    {/* Chat Modal (when a user clicks a shared agent card) */}
    {chatModalOpen && (
        <div className="chat-modal-overlay">
          <div className="chat-modal">
            <div className="chat-modal-header">
              <h3>Chat with {currentChatAgent.name}</h3>
              <button onClick={handleCloseChatModal}>X</button>
            </div>
            <div className="chat-container">
              {chatMessages.map((msg, index) => (
                <div key={index} className={`chat-message ${msg.role}`}>
                  <div className="chat-message-content">{msg.content}</div>
                </div>
              ))}
            </div>
            <div className="chat-input-container">
              <input
                type="text"
                placeholder="Type your message..."
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
              />
              <button className="send-button" onClick={handleSendChatMessage}>Send</button>
            </div>
          </div>
        </div>
      )}




    </div>
  );
}

export default Home;
